/**
 * A class describing a particular user.
 */
export class UserDetails {
  email: string;
  stores: string[];
  groups: string[];

  /**
   * @param email user's email and an identifier of a user.
   * @param stores a list of store identifiers, to which the user is assigned.
   * @param groups a list of groups to which a user belongs.
   */
  constructor(email: string, stores: string[], groups: string[]) {
    this.email = email;
    this.stores = stores;
    this.groups = groups;
  }
}
